// extracted by mini-css-extract-plugin
export default {"button":"shareButton_button__Jaoln","large":"shareButton_large__q71Ez","textButton":"shareButton_textButton__w+u-t"};